module.exports = __webpack_public_path__ + "static/media/founders-grotesk-web-regular.98b19418.woff2";